import React from 'react';
import ReactDOM from 'react-dom/client';
import "primeflex/primeflex.css";
import 'primeicons/primeicons.css';
import "primereact/resources/themes/lara-light-blue/theme.css";   // theme
import './index.css';
import App from './App';
import { UserProvider } from './context/UserProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>
);
